import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();

const selectedRegionRoadTypeState = atom({
  key: 'selectedRegionRoadType',
  default: 'lr',
  effects: [persistAtom],
});

const selectedTemporaryRegionRoadTypeState = atom({
  key: 'selectedTemporaryRegionRoadType',
  default: null,
  effects: [persistAtom],
});

const selectedCustomReportState = atom({
  key: 'selectedCustomReport',
  default: {},
  effects: [persistAtom],
});

const showMapState = atom({
  key: 'showMap',
  default: false,
  effects: [persistAtom],
});

const selectedMapViewState = atom({
  key: 'selectedMapView',
  default: 'safety',
  effects: [persistAtom],
});

export {
  selectedCustomReportState,
  selectedRegionRoadTypeState,
  selectedTemporaryRegionRoadTypeState,
  showMapState,
  selectedMapViewState,
};
